import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69835ae9921dc90014831d73_1781152560186_fb5eecdb/maryambellakbira/src/app/education-impact/page.tsx");
